module.exports = __webpack_public_path__ + "static/media/todos-other.52252006.svg";